import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import type { PreSalesProjectIndexT } from "rdx/modules/projects/types/projects/pre-sales";
import type { PostSalesProjectIndexT } from "rdx/modules/projects/types/projects/post-sales";

export type OrgProjectsReduxStateT = {
  orgProjects: {
    preSales: {
      paging: {
        itemCount: number;
        pageNumber: number;
        pageSize: number;
        hasMore: boolean;
        nextCursor?: string | null;
      };
      projects: PreSalesProjectIndexT[];
    };
    postSales: {
      paging: {
        itemCount: number;
        totalCount?: number | null;
        pageNumber: number;
        pageSize: number;
        hasMore: boolean;
      };
      providerLeads: PostSalesProjectIndexT[];
    };
    completed: {
      paging: {
        itemCount: number;
        totalCount?: number | null;
        pageNumber: number;
        pageSize: number;
        hasMore: boolean;
      };
      projects: PreSalesProjectIndexT[];
    };
    isOrgStaffTeamView: boolean;
  };
};

const pagingInitialState = {
  itemCount: 0,
  pageNumber: 0,
  pageSize: 0,
  hasMore: false,
};

const preSalesListInitialState = {
  paging: pagingInitialState,
  projects: [],
};

const postSalesListInitialState = {
  paging: pagingInitialState,
  providerLeads: [],
};

const initialState: OrgProjectsReduxStateT = {
  orgProjects: {
    preSales: preSalesListInitialState,
    postSales: postSalesListInitialState,
    completed: preSalesListInitialState,
    isOrgStaffTeamView: false,
  },
};

export const enterpriseProjectsSlice = createSlice({
  name: "enterpriseProjectsSlice",
  initialState,
  reducers: {
    setOrgStaffTeamView: (state, { payload }: PayloadAction<boolean>) => {
      state.orgProjects.isOrgStaffTeamView = payload;
    },
  },
  selectors: {
    selectIsOrgStaffTeamView: (state) => state.orgProjects.isOrgStaffTeamView,
  },
});

export const { selectIsOrgStaffTeamView } = enterpriseProjectsSlice.selectors;
export const { setOrgStaffTeamView } = enterpriseProjectsSlice.actions;

export const { orgProjects: orgProjectsInitialState } = initialState;
